/* CUBE STORE - com'e' messa la taglia scelta, e "AGGIUNGI AL CARRELLO"
   che diventa "PRENOTA"

   Quando la taglia scelta e' prenotabile, comprare e prenotare sono la
   stessa azione tecnica ma due cose diverse per il cliente: una bici
   che arriva a settembre non la si "aggiunge al carrello", la si
   prenota.

   DOVE SI LEGGE LO STATO
   Dalla riga selezionata della tabella disponibilita', che dice gia'
   PRENOTABILE, PRONTA CONSEGNA o ESAURITA. Nessun dato nuovo da
   inventare, e cambiando taglia la scritta segue da sola.

   QUATTRO STATI, UNA SOLA FONTE
   window.cubeStatoTaglia risponde 'nessuna', 'prenotabile', 'pronta',
   'esaurita' oppure null quando non si capisce. Serve anche a
   cube-azioni.js, che sui vari stati accende tasti diversi:

     nessuna     -> nessuno dei due: prima si sceglie la taglia
     prenotabile -> PRENOTA
     pronta      -> PROCEDI ALL'ACQUISTO
     esaurita    -> nessuno dei due, non c'e' niente da ordinare

   'nessuna' e null NON sono la stessa cosa, ed e' la distinzione su cui
   regge il comportamento nuovo:
     'nessuna' = la tabella c'e' e nessuna riga e' scelta, quindi il
                 cliente deve ancora decidere
     null      = la tabella non c'e' proprio (prodotti senza taglie)
   Chi legge null si comporti in modo permissivo: significa "non lo so",
   non "non si puo'". Chi legge 'nessuna' faccia il contrario: si sa che
   non si sa ancora, e finche' e' cosi' non si compra.

   ==========================================================
   L'ACCESSORIO NON DEVE SCEGLIERE NIENTE (25 agosto 2026)
   ==========================================================
   Quella distinzione aveva un buco, ed e' costato caro: la tabella C'E'
   ANCHE SUI PRODOTTI SENZA TAGLIE - accessori, ricambi - perche' li'
   serve a dire PRONTA CONSEGNA. Quindi su un portaborraccia questa
   funzione rispondeva 'nessuna', cioe' "il cliente deve ancora
   decidere", su un prodotto dove non c'e' niente da decidere.

   Segnalato da Alberto Quadrio - "C'e' un problema sugli accessori,
   chiede la taglia" - e il danno vero stava in cube-taglie.js, dove lo
   stesso equivoco bloccava l'aggiunta al carrello: verificato,
   accessorio non acquistabile, carrello fermo a zero. La storia
   completa e' li'.

   La correzione qui: se la scheda porta la classe --senza-taglia,
   l'unica riga vale come riga scelta. Cosi' lo stato torna a dire la
   verita' - 'pronta', 'prenotabile' o 'esaurita' - e un accessorio
   prenotabile puo' avere il suo tasto PRENOTA come una bici.

   Sta qui perche' qui c'e' gia' la lettura, e una seconda copia
   altrove divergerebbe al primo ritocco della tabella - in modo
   silenzioso: il pulsante direbbe una cosa e i tasti un'altra.

   L'ORDINE DEI CONTROLLI CONTA
   Prima "prenotabile", poi "esaurit", poi "pronta consegna". Le righe
   esaurite portano anche "Non ordinabile" e quelle in pronta consegna
   "Spedizione immediata": cercando la parola sbagliata per prima si
   prende lo stato sbagliato.

   DOVE STA IL TESTO NEL PULSANTE
   Non e' un figlio diretto di .add-to-cart-text: dentro ci sono due
   span, uno con l'icona del carrello e uno con la scritta. Un primo
   tentativo cercava solo fra i figli diretti e non trovava niente, e la
   scritta non cambiava mai. Qui si scende in profondita' con un
   TreeWalker e si salta quello che sta dentro l'icona, altrimenti si
   rischia di scrivere nel posto sbagliato.

   Si sostituisce SOLO quel nodo di testo, non l'elemento intero:
   riscrivere l'elemento si porterebbe via l'icona.

   PERCHE' LA SCRITTA ORIGINALE VIENE MESSA DA PARTE
   Tornando su una taglia disponibile si rimette quella vera, presa dal
   tema, invece di riscrivere "Aggiungi al carrello" a mano: il negozio
   ha piu' lingue e una copia scritta qui prima o poi si sfalserebbe.
   Vale anche per "Esaurito", che il tema scrive da se'.

   Gira anche a ogni modifica del DOM: il tema ridisegna il pulsante al
   cambio taglia, e la barra di acquisto appiccicata ne tiene una copia. */
(function () {
  var ETICHETTA = 'Prenota';

  function statoTaglia() {
    var tabella = document.querySelector('.vb-availability-card');
    if (!tabella) return null;

    /* prodotti senza taglie: la tabella c'e' lo stesso ma non c'e'
       niente da scegliere, quindi la riga unica vale come scelta.
       Vedi la nota in testa al file. */
    var senzaTaglia = tabella.classList.contains('vb-availability-card--senza-taglia');

    var sel = tabella.querySelector('.vb-availability-item.is-selected');
    if (!sel && senzaTaglia) sel = tabella.querySelector('.vb-availability-item');

    if (!sel) {
      /* la tabella c'e' ma nessuna riga e' scelta: il cliente deve
         ancora decidere. Senza righe invece non c'e' niente da
         scegliere e si torna a non saperlo. */
      if (tabella.querySelector('.vb-availability-item')) return 'nessuna';
      return null;
    }

    var testo = sel.textContent || '';
    if (/prenotabile/i.test(testo)) return 'prenotabile';
    if (/esaurit/i.test(testo)) return 'esaurita';
    if (/pronta consegna/i.test(testo)) return 'pronta';
    return null;
  }

  /* unica fonte per "com'e' messa la taglia scelta" */
  window.cubeStatoTaglia = statoTaglia;

  function nodoTesto(host) {
    var camminatore = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = camminatore.nextNode())) {
      if (!n.nodeValue || !n.nodeValue.trim()) continue;
      /* dentro l'icona ci puo' essere testo di servizio: non e' la
         scritta del pulsante */
      if (n.parentElement && n.parentElement.closest('.svg-wrapper')) continue;
      return n;
    }
    return null;
  }

  function applica() {
    var attiva = statoTaglia() === 'prenotabile';

    document.querySelectorAll('.add-to-cart-button').forEach(function (b) {
      var host = b.querySelector('.add-to-cart-text') || b;
      var nodo = nodoTesto(host);
      if (!nodo) return;

      if (attiva) {
        if (nodo.nodeValue.trim() === ETICHETTA) return;
        if (!host.dataset.cubeEtichetta) host.dataset.cubeEtichetta = nodo.nodeValue;
        nodo.nodeValue = ETICHETTA;
      } else if (host.dataset.cubeEtichetta) {
        nodo.nodeValue = host.dataset.cubeEtichetta;
        delete host.dataset.cubeEtichetta;
      }
    });
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      applica();
    });
  }

  function init() {
    applica();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
